module.exports = __webpack_public_path__ + "static/media/matilde-hat-brazil-normal.f06b453d.png";